export default __webpack_public_path__ + "static/media/breach_search_magnify.ac786f16.svg";